/* eslint-disable react/self-closing-comp */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect } from 'react';
import { useAppDispatch, useAppState } from '@components/common/context/app';
import { get } from '@evershop/evershop/src/lib/util/get';
import { motion, AnimatePresence } from 'framer-motion';
function GlobeIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6003 1.80011C8.0576 1.80011 6.54955 2.25757 5.26685 3.11465C3.98414 3.97172 2.9844 5.18991 2.39404 6.61518C1.80367 8.04044 1.64921 9.60876 1.95017 11.1218C2.25114 12.6349 2.99401 14.0247 4.08486 15.1155C5.17571 16.2064 6.56554 16.9493 8.07859 17.2502C9.59164 17.5512 11.16 17.3967 12.5852 16.8064C14.0105 16.216 15.2287 15.2163 16.0858 13.9336C16.9428 12.6509 17.4003 11.1428 17.4003 9.60011C17.3979 7.53215 16.5754 5.54958 15.1131 4.08731C13.6508 2.62504 11.6683 1.80249 9.6003 1.80011ZM16.2003 9.60011C16.2008 10.2088 16.1168 10.8146 15.9505 11.4001H13.0623C13.2463 10.2072 13.2463 8.99306 13.0623 7.80011H15.9505C16.1168 8.38565 16.2008 8.99144 16.2003 9.60011ZM7.6503 12.6001H11.5503C11.1661 13.8591 10.4991 15.0135 9.6003 15.9751C8.70185 15.0132 8.0349 13.8589 7.6503 12.6001ZM7.3578 11.4001C7.1518 10.209 7.1518 8.99127 7.3578 7.80011H11.8488C12.0548 8.99127 12.0548 10.209 11.8488 11.4001H7.3578ZM3.0003 9.60011C2.99977 8.99144 3.08383 8.38565 3.25005 7.80011H6.1383C5.95429 8.99306 5.95429 10.2072 6.1383 11.4001H3.25005C3.08383 10.8146 2.99977 10.2088 3.0003 9.60011ZM11.5503 6.60011H7.6503C8.03451 5.34117 8.70151 4.18675 9.6003 3.22511C10.4987 4.187 11.1657 5.34134 11.5503 6.60011ZM15.475 6.60011H12.8035C12.4668 5.36479 11.8993 4.20437 11.131 3.18011C12.0593 3.40311 12.9284 3.82419 13.6787 4.4145C14.429 5.00481 15.0428 5.75038 15.478 6.60011H15.475ZM8.06955 3.18011C7.30124 4.20437 6.73376 5.36479 6.39705 6.60011H3.72255C4.15775 5.75038 4.77155 5.00481 5.52186 4.4145C6.27218 3.82419 7.14126 3.40311 8.06955 3.18011ZM3.72255 12.6001H6.39705C6.73376 13.8354 7.30124 14.9959 8.06955 16.0201C7.14126 15.7971 6.27218 15.376 5.52186 14.7857C4.77155 14.1954 4.15775 13.4498 3.72255 12.6001ZM11.131 16.0201C11.8993 14.9959 12.4668 13.8354 12.8035 12.6001H15.478C15.0428 13.4498 14.429 14.1954 13.6787 14.7857C12.9284 15.376 12.0593 15.7971 11.131 16.0201Z",
    fill: "currentColor"
  }));
}
function ChevronIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "6 9 12 15 18 9"
  }));
}
export default function LanguageToggle(_ref) {
  var {
    className = ''
  } = _ref;
  var [isOpen, setIsOpen] = useState(false);
  var containerRef = useRef(null);
  var {
    fetchPageData
  } = useAppDispatch();
  var language = get(useAppState(), 'language', 'en');

  // Handle click outside to close dropdown
  useEffect(() => {
    var handleClickOutside = event => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  var setLanguage = async nextLanguage => {
    if (nextLanguage === language) return;
    setIsOpen(false);
    document.cookie = "lang=".concat(nextLanguage, "; path=/; max-age=31536000");
    var url = new URL(window.location.href);
    url.searchParams.set('lang', nextLanguage);
    var ajaxUrl = new URL(url.toString());
    ajaxUrl.searchParams.set('ajax', 'true');
    await fetchPageData(ajaxUrl);
    window.history.replaceState({}, '', url.toString());
  };
  var languages = [{
    code: 'en',
    label: 'EN'
  }, {
    code: 'ar',
    label: 'AR'
  }];
  var currentLang = languages.find(l => l.code === language) || languages[0];
  var otherLangs = languages.filter(l => l.code !== language);
  return /*#__PURE__*/React.createElement("div", {
    className: "relative flex items-center ".concat(className, " ").concat(language === 'ar' ? 'ml-8' : ''),
    ref: containerRef
  }, /*#__PURE__*/React.createElement(motion.div, {
    animate: {
      height: isOpen ? 'auto' : '40px'
    },
    transition: {
      duration: 0.3,
      ease: [0.04, 0.62, 0.23, 0.98]
    },
    className: "flex flex-col border-2 border-white rounded-[20px] overflow-hidden bg-transparent"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => setIsOpen(!isOpen),
    className: " flex ".concat(language === 'ar' ? 'flex-row-reverse' : 'flex-row', " items-center gap-2 px-4 py-2 text-white h-[36px] whitespace-nowrap outline-none")
  }, /*#__PURE__*/React.createElement(GlobeIcon, null), /*#__PURE__*/React.createElement("span", {
    className: "text-[1.12rem] !font-[400] uppercase mt-[3px] md:mt-0"
  }, currentLang.label), /*#__PURE__*/React.createElement(motion.div, {
    animate: {
      rotate: isOpen ? 0 : -90
    },
    transition: {
      duration: 0.3
    },
    className: "flex items-center justify-center"
  }, /*#__PURE__*/React.createElement(ChevronIcon, null))), /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: false
  }, isOpen && /*#__PURE__*/React.createElement(motion.div, {
    initial: {
      opacity: 0,
      height: 0
    },
    animate: {
      opacity: 1,
      height: 'auto'
    },
    exit: {
      opacity: 0,
      height: 0
    },
    transition: {
      duration: 0.3,
      ease: [0.04, 0.62, 0.23, 0.98]
    },
    className: "flex flex-col"
  }, otherLangs.map(lang => /*#__PURE__*/React.createElement("button", {
    key: lang.code,
    type: "button",
    onClick: () => setLanguage(lang.code),
    className: " flex ".concat(language === 'ar' ? 'flex-row-reverse' : 'flex-row', " items-center gap-2 px-4 py-2 text-white hover:bg-white/10 transition-colors duration-200 h-[36px] whitespace-nowrap outline-none")
  }, /*#__PURE__*/React.createElement(GlobeIcon, null), /*#__PURE__*/React.createElement("span", {
    className: "text-[1.12rem] !font-[400] uppercase mt-[3px] md:mt-0"
  }, lang.label), /*#__PURE__*/React.createElement("div", {
    className: "w-[12px]"
  })))))));
}